/**
 * helper-tracking
 * change src for stage and live tracking URL
 *
 * insert in variables the stage and live tracking url
 * insert stage URL without HTTP://
 *
 */
(function() {
  let liveTrackingURL = '//assets.adobedtm.com/8665cc68f8ef/b155ef11bdec/launch-ae225d5cc16b.min.js',
    stageTrackingURL = '//assets.adobedtm.com/8665cc68f8ef/b155ef11bdec/launch-443506934e90-staging.min.js',
    stageURL = 'stage.p941c186.bloonix.cloud';

  switch (location.hostname) {
    case "" + stageURL + "":
      let script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "" + stageTrackingURL + "";
      script.innerHTML = null;
      script.id = "trackingIc";
      script.async = true;
      document.head.appendChild(script);
      break;
    case "localhost":
      let scriptLocal = document.createElement("script");
      scriptLocal.type = "text/javascript";
      scriptLocal.src = "" + stageTrackingURL + "";
      scriptLocal.innerHTML = null;
      scriptLocal.id = "trackingIc";
      scriptLocal.async = true;
      document.head.appendChild(scriptLocal);
      break;
    default:
      let scriptLive = document.createElement("script");
      scriptLive.type = "text/javascript";
      scriptLive.src = "" + liveTrackingURL + "";
      scriptLive.innerHTML = null;
      scriptLive.id = "trackingIc";
      scriptLive.async = true;
      document.head.appendChild(scriptLive);
  }
})();